import LocalTime from 'local-time'

import '@hotwired/turbo-rails'
import './public_controllers'
import '@37signals/lexxy'

LocalTime.start()
